import { combineReducers } from 'redux';

import auth from '../reducers/auth';
import posts from '../reducers/posts';

export const reducers = combineReducers({ auth, posts });